import { useErrors } from '../../hooks/useErrors';
import { useState } from 'react';
import { ApiOrder } from '../../types';
import { AddressModalInput } from './AddressModalInput';
import { EditAddressModal } from './EditAddressModal';

type BillingAddressFields = 'careOf' | 'city' | 'company' | 'email' | 'street' | 'zip';

const REQUIRED_FIELDS = ['city', 'company', 'email', 'street', 'zip'];

export const EditBillingAddressModal = ({
	billingAddress,
	setBillingAddress,
}: {
	billingAddress: ApiOrder['billing'];
	setBillingAddress: (address: ApiOrder['billing']) => void;
}) => {
	const [address, setAddress] = useState({ ...billingAddress });
	const { errors, setErrors, validate } = useErrors();

	const handleChange = (e: { target: { name: string; value: string } }) => {
		setAddress((prev) => ({ ...prev, [e.target.name]: e.target.value }));

		const key = e.target.name as BillingAddressFields;

		validate(e.target.value, key, { required: REQUIRED_FIELDS.includes(key) });
	};

	const onBlur = () => {
		setErrors({});

		for (const field of Object.keys(address)) {
			const key = field as BillingAddressFields;

			validate(address[key], key, { required: REQUIRED_FIELDS.includes(key) });
		}
	};

	return (
		<EditAddressModal
			onSave={() => {
				setBillingAddress(address);
			}}
			disabled={Object.values(errors)
				.map(({ valid }) => valid)
				.some((valid) => !valid)}
		>
			<div className="edit-address-content-main">
				{(Object.keys(address) as BillingAddressFields[]).map((key: BillingAddressFields) => (
					<AddressModalInput
						key={key}
						name={key}
						value={address[key]}
						errors={errors}
						onChange={handleChange}
						onBlur={onBlur}
					/>
				))}
			</div>
		</EditAddressModal>
	);
};
